import React from "react";

const Headline = () => {
  return (
    <div className="flex flex-col gap-1 items-center mb-8">
      <h2 className="text-[#323338]" style={{ fontWeight: 600 }}>
        Share items across boards — automatically
      </h2>
      <p className="text-sm text-[#676879] text-center max-w-md">
        Keep your team aligned by mirroring items from one board to another in real time. No manual
        copy-paste ever again.
      </p>
    </div>
  );
};

export default Headline;
